// extracted by mini-css-extract-plugin
module.exports = {"root":"WysiwygBlock_root__hUP_O"};